import React from 'react';

import './CheckBox.css';

const CheckBox = (props) => {
  const { className } = props;

  const attributes = {
    ...props,

    type: 'checkbox',

    className: `form-input-checkbox${className ? ` ${className}` : ''}`,

    'iso-latin-only': '',
  };

  return (
    <div className="form-input-checkbox-parent">
      <input {...attributes} />
      <div className="form-input-checkbox-icon" />
    </div>
  );
};

export default CheckBox;
